import type { CustomMeta } from "@/interfaces";
import { routes } from "@/router";
import { computed } from "vue";
import { useRoute } from "vue-router";

const DEFAULT_METADATA: CustomMeta = {
  displayName: "menu.home",
  svg: "fas-rectangle-list",
  color: "#A76800",
};

export function useRouteGroupMeta<T>(useDefault = false) {
  const route = useRoute();
  const selectedDefault = useDefault ? DEFAULT_METADATA : null;

  const getParentRoute = () => {
    for (const group of routes) {
      if (group.name === route.name) {
        return group;
      }

      if (!group.children) {
        continue;
      }

      for (const child of group.children || []) {
        if (child.name === route.name) {
          if (!group.redirect) {
            return child;
          }

          const mainRoute = (group.children || []).find(
            (i) => i.name === group.redirect?.name,
          );
          if (mainRoute) {
            return mainRoute;
          }

          return child;
        }
      }
    }
  };

  const meta = computed(() => {
    const groupRoute = getParentRoute();

    if (!groupRoute) {
      return selectedDefault as T;
    }

    return groupRoute.meta as unknown as T;
  });

  return meta;
}
